import directive from './directives'
const importDirective = (Vue) => {
	Vue.directive('dragScroll', directive.dragscroll)
	Vue.directive('hasPerm', directive.hasPerm)
}

export default importDirective
